var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-center",
            "ok-only": "",
            centered: "",
            title: "Payment Widget Preview",
            static: true
          }
        },
        [
          _c("div", { staticStyle: { display: "inline" } }, [
            _c("code", [_vm._v('\n        <div id="cdsgpw" cfg-id="')]),
            _vm._v(_vm._s(_vm.pwConfigNumber)),
            _c("code", [_vm._v('"/>\n      ')])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }